export const GET_PERSONALIZATION_BLOCK_BY_ID_M = (id, preview: boolean) => `
  query {
    personalizationBlock(id: "${id}", preview: ${preview}) {
      fallbackVariation {
          __typename
          ...on AccordionBlock{sys{id} audienceCollection{items{audianceId}}}
          ...on ContactBlock {sys{id} audienceCollection{items{audianceId}}}
          ...on FaqListBlock {sys{id} audienceCollection{items{audianceId}}}
          ...on FileBlock{sys{id} audienceCollection{items{audianceId}}}
          ...on ImageBlock {sys{id} audienceCollection{items{audianceId}}}
          ...on InformationBlock {sys{id} audienceCollection{items{audianceId}}}
          ...on Link {sys{id} audienceCollection{items{audianceId}}}
          ...on RestrictedRichTextBlock{sys{id} audienceCollection{items{audianceId}}}
          ...on RichTextBlock{sys{id} audienceCollection{items{audianceId}}}
          ...on Sectionblock {sys{id} audienceCollection{items{audianceId}}}
          ...on TableBlock {sys{id} audienceCollection{items{audianceId}}}
          ...on TeaserBlock{sys{id} audienceCollection{items{audianceId}}}
          ...on TimelineBlock {sys{id} audienceCollection{items{audianceId}}}
          ...on Videoblock {sys{id} audienceCollection{items{audianceId}}}
      }
      variantsCollection {
        items {
            __typename
            ...on AccordionBlock{sys{id} audienceCollection{items{audianceId}}}
            ...on ContactBlock {sys{id} audienceCollection{items{audianceId}}}
            ...on FaqListBlock {sys{id} audienceCollection{items{audianceId}}}
            ...on FileBlock{sys{id} audienceCollection{items{audianceId}}}
            ...on ImageBlock {sys{id} audienceCollection{items{audianceId}}}
            ...on InformationBlock {sys{id} audienceCollection{items{audianceId}}}
            ...on Link {sys{id} audienceCollection{items{audianceId}}}
            ...on RestrictedRichTextBlock{sys{id} audienceCollection{items{audianceId}}}
            ...on RichTextBlock{sys{id} audienceCollection{items{audianceId}}}
            ...on Sectionblock {sys{id} audienceCollection{items{audianceId}}}
            ...on TableBlock {sys{id} audienceCollection{items{audianceId}}}
            ...on TeaserBlock{sys{id} audienceCollection{items{audianceId}}}
            ...on TimelineBlock {sys{id} audienceCollection{items{audianceId}}}
            ...on Videoblock {sys{id} audienceCollection{items{audianceId}}}
        }
    }
    }
  }
`;
